import React, {Fragment} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchUserTopPhotos, resetUserTopPhotos} from "../../../../creators/user.top.photos";

import Thumb from '../../../components/Thumb';
import {PageLoader} from "../../../components/Loader";
import Icon from "../../../components/Icon";
import {Link} from "react-router-dom";
import createLink from "../../../../libs/createLink";


class ProfileBestPhotos extends React.Component {
    componentDidMount() {
        this.props.fetchUserTopPhotos(this.props.user._id, {
            kind: "gallery",
            limit: 6,
            sort: "-count.like",
            isTotal: false
        });
    }

    componentWillUnmount() {
        this.props.resetUserTopPhotos();
    }

    render() {
        return !this.props.userTopPhotosInitialized ? (
            <div className={"card profil-best-medias"}>
                <PageLoader/>
            </div>
        ) : (
            <div className="card profil-best-medias">
                <div className="title">
                    Meilleures photos
                </div>
                {this.props.userTopPhotosTotal > 0 ? (
                    <Fragment>
                        <div className="thumb-group">
                            {this.props.userTopPhotos.map((item, index) => {
                                return (
                                    <Thumb
                                        key={index}
                                        {...item}
                                        isMe={this.props.isMe}
                                        miniatureOnly
                                        isMiniature={"mini"}
                                    />
                                )
                            })}
                        </div>
                        <span className="see-more">
                            <Link
                                to={this.props.isMe ? createLink('userMeAlbums', this.props.user) : createLink('userAlbums', this.props.user)}>Toutes les photos</Link>
                            <Icon type="chevron-right"/>
                        </span>
                    </Fragment>
                ) : (
                    <div className={"no-content"}>Aucune meilleure photo</div>
                )}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        userTopPhotos: state.userTopPhotos.data,
        userTopPhotosLoading: state.userTopPhotos.loading,
        userTopPhotosInitialized: state.userTopPhotos.initialized,
        userTopPhotosTotal: state.userTopPhotos.data && state.userTopPhotos.data.length,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUserTopPhotos,
    resetUserTopPhotos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ProfileBestPhotos);
